// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { MDBCol, MDBContainer, MDBRow } from 'mdbreact';
import BasePaySection from './BasePaySection';
import DividedPaySection from './DividedPaySection';
import VariablePaySection from './VariablePaySection';
import FundsInfoSection from './FundsInfoSection';
import { Field } from 'redux-form';
import InputField from '../../../layout/reduxForm/customFields/InputField';
import CheckboxField from '../../../layout/reduxForm/customFields/CheckboxField';
import SelectField from '../../../layout/CustomSelect';

const PayInfoSection = ({ isWorkOrderAssigned }) => (
  <>
  <div className="fields_group">
    <BasePaySection isWorkOrderAssigned={isWorkOrderAssigned} />
    <VariablePaySection isWorkOrderAssigned={isWorkOrderAssigned} />
    <DividedPaySection />
  
  </div>
    <FundsInfoSection />
  

    </>
);

export default PayInfoSection;
